export const TRANSITION_VIOLATION = 'Transition violation'
export const INVALID_UNLOCK_KEY = 'Invalid unlock key'
export const LOCK_VIOLATION = 'Lock violation'
export const UNREACHABLE_STATE = 'Unreachable state'

export class MachineError extends Error {}
